export enum TriggerType {
  AttributeChange = 'Automations::Triggers::AttributeChange',
  ObjectCreated = 'Automations::Triggers::ObjectCreated',
}

export enum ActionType {
  SetAttribute = 'Automations::Actions::SetAttribute',
  CreateUnderwritingModel = 'Automations::Actions::CreateUnderwritingModel',
}

export type ChainOperator = 'none' | 'and' | 'or';
export type BasicSetupArgs = Pick<Automation, 'name' | 'target_model'>;
export type TriggersSetupArgs = Pick<Automation, 'triggers'>;
export type ActionsSetupArgs = AutomationParam<ActionType>;

export interface AutomationParam<T> {
  id?: number;
  attr: string;
  type: T;
  value: any;
}

export type Automation = {
  id?: number;
  is_active: boolean;
  name: string;
  target_model: string;
  triggers: AutomationParam<TriggerType>[];
  actions: AutomationParam<ActionType>[];
};
